import Tooltip from '@mui/material/Tooltip';

function TooltipDecorator({ children, contentState, entityKey }) {
  const { title } = contentState.getEntity(entityKey).getData();
  return (
    <Tooltip title={title}>
      <span css={rootCss}>{children}</span>
    </Tooltip>
  );
}

const rootCss = ({ palette }) => ({
  backgroundColor: palette.primary.background,
  display: 'inline-block',
  borderRadius: 8,
  padding: '2px 4px',
  cursor: 'help',
});

export default {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'TOOLTIP';
    }, callback);
  },
  component: TooltipDecorator,
};
